import { useState } from "react";
import { useDocumentationArea } from "src/apps/hooks/useDocumentationArea";
import type { ActorAccess } from "src/contexts/documentationArea/domain/ActorAccess";
import type { ActorActionName } from "src/contexts/documentationArea/domain/ActorAction";

const isActorAccess = (value: unknown): value is ActorAccess => {
  if (typeof value !== "object" || value === null) return false;
  const access = value as Partial<ActorAccess>;
  return typeof access.email === "string" && typeof access.userLinkId === "string";
};

export const useActorActionsMenu = () => {
  const { actor } = useDocumentationArea();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeAction, setActiveAction] = useState<ActorActionName | null>(null);

  const actions = actor?.getActions() ?? [];
  const revokeOption = actions.find((option) => option.action === "delete_user_access");
  const revokeTargets = revokeOption?.data?.["revocableAccesses"];
  const revocableAccesses = Array.isArray(revokeTargets) ? revokeTargets.filter(isActorAccess) : [];

  const handleOptionAction = (action: ActorActionName) => {
    setIsMobileMenuOpen(false);
    setActiveAction(action);
  };

  return {
    actions,
    revokeOption,
    revocableAccesses,
    isMobileMenuOpen,
    activeAction,
    openMobileMenu: () => setIsMobileMenuOpen(true),
    closeMobileMenu: () => setIsMobileMenuOpen(false),
    handleOptionAction,
    closeActiveAction: () => setActiveAction(null),
  };
};
